import React from 'react';

function ManageOrders(props) {
    return (
        <div>
            <h1>Manage Orders</h1>
        </div>
    );
}

export default ManageOrders;